<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4 class="text-bold">Contact Consultant</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="">Choose Problem</label>
              <select class="form-control" v-model="problem">
                <option value="null">Choose A problem</option>
                <option
                  v-for="(template, index) in templates"
                  :key="template.id"
                  :value="index"
                >
                  {{ template.problem_title }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-12 text-black" v-if="problem != null">
            <span>
              Lieber XXX,<br /><br />
              <p v-html="getText()"></p>
            </span>
            <div class="form-group">
              <label>Optional zusätzlicher Text:</label>
              <textarea
                class="form-control"
                v-model="message"
                rows="5"
              ></textarea>
            </div>
            <p v-html="team"></p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button class="btn btn-primary" @click="$router.back()">
              Back
            </button>
          </div>
          <div class="col-md-6 text-right" v-if="problem != null">
            <button class="btn btn-success" @click="checkTemplateView()">
              Check Template View
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="container-fluid" v-if="templateLink">
              <iframe
                :src="templateLink"
                frameborder="0"
                width="100%"
                height="700px"
              ></iframe>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary" @click="sendEmail()">
              Sent Email
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      templateLink: null,
      problem: null,
      intro: `unsere Produktion hat eine Rückfrage zu deinem Hemd mit der Bestellnummer ${this.$route.params.order_number}.<br><br>`,
      templates: [],
      extra:
        "Bitte überprüfe nochmal deine Angabe und aktualisiere diese in deinem Befeni System.<br><br><b>Bitte beachten:<br>Schicke uns bitte unbedingt die korrigierte Größe zusätzlich als Antwort auf diese E-Mail. Ansonsten können wir das Hemd nicht produzieren!</b><br><br>Danke für deine Mithilfe.<br><br>",
      message: null,
      team: `Viele Grüße<br>Dein Team von Befeni<br><br>`,
    };
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    async getTemplates() {
      let res = await axios.get("settings/email_template");
      this.templates = res.data;
    },
    getText() {
      return (
        this.intro + this.templates[this.problem].message + "<br>" + this.extra
      );
    },
    finalTemplate() {
      let message = this.message != null ? this.message : "";
      return (
        this.intro +
        this.templates[this.problem].message +
        "<br>" +
        this.extra +
        message
      );
    },
    async checkTemplateView() {
      let html = this.finalTemplate();
      let res = await axios({
        url: "shirt_orders/email/template/",
        method: "POST",
        data: {
          shirtOrderId: this.$route.params.order_number,
          consultantId: this.$route.params.id,
          html: html,
          team: this.team,
        },
        responseType: "blob", // important
      });
      if (res) {
        var file = new Blob([res.data], {
          type: "text/html",
        });
        var url = URL.createObjectURL(file);
        this.templateLink = url;
        show_modal("#modal-box");
      }
    },
    async sendEmail() {
      let result = await Swal.fire({
        title: "Are you sure ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "YES",
        cancelButtonText: "NO",
      });
      if (result.value) {
        $(".loading").show();
        let params = {
          order_number: this.$route.params.order_number,
          text: this.finalTemplate(),
          consultant_id: this.$route.params.id,
        };
        let res = await axios.post(
          "shirt_orders/send/email_to_consultant",
          params
        );
        if (res) {
          hide_modal("#modal-box");
          $(".loading").hide();
          toastr.success("Successfully Sent Email");
        }
      }
    },
  },
};
</script>
<style scoped>
.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
  z-index: 99999999;
}
</style>
